import { Model } from '@models'
import { unlessEventHasSelectedDate } from '@src/models/utils'
import { JournalEntry } from '@src/types'
import CREATE_JOURNAL_ENTRY from '../graphql/createJournalEntry'
import DELETE_JOURNAL_ENTRY from '../graphql/deleteJournalEntry'
import UPDATE_JOURNAL_ENTRY from '../graphql/updateJournalEntry'

const journalEntriesCacheClearPayload = (response: JournalEntry) => ({
  includeDates: [response.occurredAt],
})

export default class JournalEntries {
  namespace = 'journalEntries'

  state = {
    ...Model.defaultState,
  }

  effects = {
    create: Model.buildEffect({
      name: `${this.namespace}/create`,
      optimistic: true,
      query: CREATE_JOURNAL_ENTRY,
      dataPath: 'createJournalEntry',
      optimisticReducers: [
        { name: 'events/backup', storePath: 'events' },
        {
          name: 'events/appendOrReplaceList',
          unless: unlessEventHasSelectedDate,
          storePath: 'events',
        },
      ],
      reducers: [
        {
          name: 'events/appendOrReplaceList',
          replaceFake: true,
          unless: unlessEventHasSelectedDate,
          storePath: 'events',
        },
      ],
      errorReducers: [{ name: 'events/restore', storePath: 'events' }],
      cacheReducers: [
        {
          name: 'events/cacheClear',
          payload: { ...journalEntriesCacheClearPayload, matchName: 'events/fetch' },
        },
        {
          name: 'insights/cacheClear',
          payload: journalEntriesCacheClearPayload,
        },
      ],
    }),
    delete: Model.buildEffect({
      name: `${this.namespace}/delete`,
      optimistic: true,
      query: DELETE_JOURNAL_ENTRY,
      dataPath: 'deleteJournalEntry',
      variables: ({ id }: JournalEntry) => ({ id }),
      optimisticReducers: [
        { name: 'events/backup', storePath: 'events' },
        { name: 'events/deleteList', storePath: 'events' },
      ],
      errorReducers: [{ name: 'events/restore', storePath: 'events' }],
      cacheReducers: [
        {
          name: 'events/cacheClear',
          payload: { ...journalEntriesCacheClearPayload, matchName: 'events/fetch' },
        },
        {
          name: 'insights/cacheClear',
          payload: journalEntriesCacheClearPayload,
        },
      ],
    }),
    update: Model.buildEffect({
      name: `${this.namespace}/update`,
      optimistic: true,
      query: UPDATE_JOURNAL_ENTRY,
      dataPath: 'updateJournalEntry',
      optimisticReducers: [
        { name: 'events/backup', storePath: 'events' },
        {
          name: 'events/appendOrReplaceList',
          unless: unlessEventHasSelectedDate,
          storePath: 'events',
        },
      ],
      reducers: [
        {
          name: 'events/appendOrReplaceList',
          replaceFake: true,
          unless: unlessEventHasSelectedDate,
          storePath: 'events',
        },
      ],
      errorReducers: [{ name: 'events/restore', storePath: 'events' }],
      cacheReducers: [
        {
          name: 'events/cacheClear',
          payload: { ...journalEntriesCacheClearPayload, matchName: 'events/fetch' },
        },
        {
          name: 'insights/cacheClear',
          payload: journalEntriesCacheClearPayload,
        },
      ],
    }),
  }

  reducers = {
    ...Model.defaultReducers,
  }
}
